import { render, staticRenderFns } from "./SendToWppModal.vue?vue&type=template&id=3790cc67"
import script from "./SendToWppModal.vue?vue&type=script&lang=js"
export * from "./SendToWppModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports